import { render, staticRenderFns } from "./ColumnDatalabel.vue?vue&type=template&id=4ce86274&"
import script from "./ColumnDatalabel.vue?vue&type=script&lang=js&"
export * from "./ColumnDatalabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports